import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const OrderSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  li > div {
    padding-inline-start: 0;
    margin-inline-start: ${primitive.$spacing4};
    border-block-end: ${p => p.theme.token('border-default')};
  }
  li:last-of-type > *:first-child {
    border-block-end: none;
  }
`;
